<template>
  <div>
    <v-card class="pa-3 rounded-lg" elevation="1">
      <v-skeleton-loader
        type="article, actions"
        v-if="!dataSet"
      ></v-skeleton-loader>
      <div v-if="dataSet">
        <div v-if="dataSet.length">
          <h3>Comment</h3>
          <v-card
            class="rounded_max pa-3 mb-3 mt-2"
            elevation="1"
            v-for="(item, i) in dataSet"
            :key="i"
          >
            <div class="d-flex justify-space-between">
              <div class="d-flex align-end py-2" style="height: 100%">
                <router-link
                  v-if="item.data_user.role == 'SCHOLAR'"
                  class="opener_name d-flex pa-1"
                  :to="`/scholar/${item.user_id}`"
                >
                  <v-avatar class="mr-3">
                    <img
                      :src="
                        item.data_user.profile_picture
                          ? item.data_user.profile_picture
                          : ava
                      "
                      class="obj_fit"
                      alt=""
                    />
                  </v-avatar>
                  <div>
                    <h4 class="black--text">{{ item.data_user.name }}</h4>
                    <small class="grey--text">
                      {{ $date(item.created_at).fromNow() }}</small
                    >
                  </div>
                </router-link>
                <div class="d-flex pa-1" v-else>
                  <v-avatar class="mr-3">
                    <img
                      :src="
                        item.data_user.profile_picture
                          ? item.data_user.profile_picture
                          : ava
                      "
                      class="obj_fit"
                      alt=""
                    />
                  </v-avatar>
                  <div>
                    <h4 class="black--text">{{ item.data_user.name }}</h4>
                    <small class="grey--text">
                      {{ $date(item.created_at).fromNow() }}</small
                    >
                  </div>
                </div>
              </div>
              <v-hover v-slot="{ hover }">
                <v-btn
                  class="text-capitalize"
                  depressed
                  dark
                  color="blue"
                  text
                  @click="quote(item)"
                >
                  <v-icon>mdi-tooltip-plus</v-icon>
                  <v-expand-x-transition>
                    <p class="ma-0" v-if="hover">Quote</p>
                  </v-expand-x-transition>
                </v-btn>
              </v-hover>
            </div>
            <p class="ma-0 small_txt" v-if="item.quote">Quote:</p>
            <div
              v-if="item.quote"
              class="pa-2"
              style="background-color: #eeeeee"
            >
              <div class="d-flex align-center" v-if="item.data_user_quote">
                <v-icon small class="mr-1">mdi-comment-arrow-right</v-icon>
                <b class="small_txt"
                  >Comment By
                  <router-link
                    class="opener_name"
                    :to="
                      item.data_user_quote.role == 'SCHOLAR'
                        ? `/scholar/${item.data_user_quote.id}`
                        : ''
                    "
                  >
                    {{ item.data_user_quote.name }}
                  </router-link>
                </b>
              </div>
              <div>
                <p class="ma-0">{{ item.quote }}</p>
              </div>
            </div>
            <div class="mt-3">
              <p>
                {{ item.content }}
              </p>
            </div>

            <div class="d-flex justify-end">
              <v-card
                height="max-content"
                outlined
                class="rounded-lg d-flex align-center"
                v-if="item.user_id == id"
              >
                <v-tooltip top color="#006341">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      @click="updateComment(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Comment</span>
                </v-tooltip>
                <v-tooltip top color="#006341">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      color="red"
                      @click="deleteComment(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Comment</span>
                </v-tooltip>
              </v-card>
            </div>
          </v-card>
        </div>
        <div
          class="d-flex align-center justify-center flex-column"
          v-if="!dataSet.length"
          style="height: 100%"
        >
          <img
            src="../../../assets/img/gundam/no_comment.png"
            height="150px"
            alt=""
          />
          <b class="default_txt my-3">Be the first to comment!</b>
        </div>
        <div>
          <v-card flat color="grey">
            <div class="pa-2" v-if="this.isQuote">
              <div class="d-flex justify-space-between">
                <p class="white--text ma-0 small_txt pt-2 px-2">Quote</p>
                <v-btn class="ml-2" small icon @click="deleteQuote">
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card class="pa-3" flat style="width: 100%">
                {{ dataQuote.content }}
              </v-card>
            </div>
            <v-textarea
              name="comment"
              id="fieldComment"
              hide-details
              ref="typist"
              v-model="comment"
              label="Write comment"
              auto-grow
              solo
            ></v-textarea>
          </v-card>
          <div>
            <div class="d-flex justify-end">
              <v-btn
                class="mt-3 blue text-capitalize"
                dark
                v-if="!saving"
                @click="createComment()"
                ><v-icon class="mr-2">mdi-tooltip-check</v-icon>Comment</v-btn
              >
              <v-btn class="mt-3 blue text-capitalize" v-if="saving" dark
                >Loading...</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <div class="pa-3">
      <dialog-small
        :d_small="d_small"
        @close="d_small = false"
        @refetch="fetchData"
        :type="d_type"
        :inventory="inventory"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dialogSmall from "../../dialog/dialogSmall.vue";
export default {
  components: { dialogSmall },
  name: "commentThread",
  computed: {
    ...mapState({
      id: (state) => state.id,
      ava: (state) => state.ava,
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      d_create: false,
      d_large: false,
      d_small: false,
      d_type: "",
      d_title: "",
      inventory: null,
      dataSet: null,
      loading: false,
      total: null,
      last_page: null,
      comment: "",
      find: "",
      limit: 10,
      page: 1,
      saving: false,
      isQuote: false,
      dataQuote: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async quote(item) {
      this.isQuote = true;
      this.dataQuote = item;
      this.$refs["typist"].$refs.input.focus();
      setTimeout(
        () =>
          window.scrollTo({
            left: 0,
            top: document.body.scrollHeight + 2000,
            behavior: "smooth",
          }),

        100,
      );
    },
    deleteQuote() {
      this.isQuote = false;
      this.dataQuote = [];
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `forum/thread/comment/${this.$route.params.idThread}?include=dataUser,dataReply,dataUserQuote`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    createComment() {
      this.saving = true;
      let body = {
        course_forum_id: this.$route.params.idThread,
        content: this.comment,
        user_quote_id: this.isQuote ? this.dataQuote.id : null,
        quote: this.isQuote ? this.dataQuote.content : null,
        user_id_quote: this.isQuote ? this.dataQuote.user_id : null,
      };
      let data = {
        path: `forum/thread/comment`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.comment = "";
          this.picture = null;
          this.saving = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.fetchData();
          this.deleteQuote();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.saving = false;
        });
    },
    updateComment(item) {
      this.d_type = "u_threadcomment";
      this.inventory = JSON.parse(JSON.stringify(item));
      this.d_title = "Update Comment";
      this.d_small = true;
    },
    deleteComment(item) {
      this.d_type = "d_threadcomment";
      this.inventory = item;
      this.d_title = "Delete Comment";
      this.d_small = true;
    },
  },
};
</script>

<style></style>
